import { Fragment } from 'react';

import { Button, Card, Spinner } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { SchemaForm } from '../schema/form/schema-form';
import { useCarrierContractSchemaQuery } from '../schema/queries';

interface Props {
  isAuthFormDisabled?: boolean;
  onShowAuthForm?: () => void;
  schemaId: string;
}

export function Configuration(props: Props) {
  const { schemaId, onShowAuthForm, isAuthFormDisabled } = props;

  const { data: schema, isLoading } = useCarrierContractSchemaQuery(schemaId);
  const { t } = useTranslation();

  const hasAuthForm = !!schema?.authentication_form_json_schema;

  if (isLoading || !schema) {
    return <Spinner />;
  }

  return (
    <Fragment>
      {hasAuthForm && (
        <Fragment>
          <Button variant="secondary" onClick={onShowAuthForm} disabled={isAuthFormDisabled}>
            {t('carrierContracts.create.authForm.title')}
          </Button>

          <Card.Separator />
        </Fragment>
      )}

      <p style={{ color: 'var(--grey-66)', margin: 0 }}>{t('carrierContracts.create.helpText')}</p>

      {Object.entries(schema.json_schema).map(([key, value]) => (
        <SchemaForm path={`carrier_configuration_data.${key}`} schemaId={schemaId} schema={value} key={key} />
      ))}
    </Fragment>
  );
}
